import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const ClientsPage = lazy(() => import('./ClientsPage'));

const ClientsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.Sales,
  routes: [
    {
      path: 'clients',
      element: <ClientsPage />,
    },
  ],
};

export default ClientsConfig;
